import styled from "styled-components";
import Block from "components/layout/Block";

const StyledAvatarNotVip = styled(Block)`
	min-width: 50px;
	img {
		filter: blur(7px);
	}
	cursor: pointer;
`;

export default StyledAvatarNotVip;
